import { Component, ViewChild, ElementRef, AfterViewInit , OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ApiService } from '../../api/api.service';
import { FormService } from '../../api/form.service';
import { first } from 'rxjs/operators';
import { result } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-testlogin',
  templateUrl: './testlogin.component.html',
  styleUrls: ['./testlogin.component.css']
})
export class TestloginComponent implements OnInit {

  public loginForm:any;
  submitted = false;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private router: Router,
    private formaction: FormService
  ) { }

  ngOnInit(): void {

    window.localStorage.setItem("logged_in", "FALSE");
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    })


  }

  get f() { return this.loginForm.controls; }


  onLoginSubmit(){

    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
  }

    var args = this.loginForm.value;

    var email  = this.loginForm.value['email'];
    var password = this.loginForm.value['password'];


    this.api.loginCheck(args).subscribe((result:any)=>{
      console.log(result);
      var data = [result];


      this.formaction.set_family_head_result(data);
      //console.log(result[0]['count']);
      //var count = result[0]['count'];

      if(result.status == "fail"){
        alert("fail to retry");
        return;
      }
      else{
        var result_email = result.email;
        var result_password = result.password;

        if((email===result_email) && (password === result_password)){
          alert("login Sucess");
          window.localStorage.setItem("logged_in", "TRUE");
          window.localStorage.setItem("regNo", result.refno );
          this.router.navigateByUrl('/testReg');
          // this.router.navigateByUrl('/testDashboard');
// this.router.navigateByUrl('/testeditreg');

          return;
        }
        else{
          alert("fail to retry");
          return;
        }
      }

      // if(1 == count){
      //   alert("login Sucess");
      //   return;
      // }
      // else{
      //   alert("fail to retry");
      //   return;
      // }
    })
  }


omit_text(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_text_number(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_email(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 46 || k==64 || k==95 || k==32);
}
omit_number(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_spl(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_addres(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_decimal(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32 || k == 46);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

  public password:string = 'password';
public eye_bool:boolean = false;
public eyeSlash_bool:boolean = true;
eye(){
this.password = 'password';
this.eyeSlash_bool = true;
  this.eye_bool = false;
}
eyeSlash(){
  this.password = 'text'
  this.eyeSlash_bool = false;
  this.eye_bool = true;
}

}
